import { sessionStorageGetItem } from '../StorageUtils';

export const checkSessionForUtm = () => sessionStorageGetItem('utm') || undefined;

export const checkSessionForReferrer = () => sessionStorageGetItem('referrer') || undefined;

export const checkSessionForWhitelabelSupplierId = () => sessionStorageGetItem('whitelabel') || undefined;

export const checkSessionForReferrerOrUtm = () => checkSessionForUtm() || checkSessionForReferrer();
